/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Creditspartmonthly2Inputs */

const en_creditspartmonthly2 = /** @type {(inputs: Creditspartmonthly2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This month`)
};

const de_creditspartmonthly2 = /** @type {(inputs: Creditspartmonthly2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monat`)
};

/**
* | output |
* | --- |
* | "This month" |
*
* @param {Creditspartmonthly2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const creditspartmonthly2 = /** @type {((inputs?: Creditspartmonthly2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Creditspartmonthly2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_creditspartmonthly2(inputs)
	return de_creditspartmonthly2(inputs)
});
export { creditspartmonthly2 as "creditsPartMonthly" }